export const segments = [
  {
    slug: "handwerk",
    navLabel: "Für Handwerksbetriebe",
    eyebrow: "Für Handwerksbetriebe",
    h1: "Das Angebot ist fertig, bevor Sie den Bauwagen verlassen haben.",
    metaDescription:
      "Automatisierung für Handwerksbetriebe: Angebote direkt bei der Besichtigung erstellen und versenden, Rechnungen automatisch stellen.",
    painPoint:
      "Sie sind auf der Baustelle, beim Kunden vor Ort oder von Termin zu Termin unterwegs. Für Angebote, Rechnungen oder liegen gebliebene Anfragen bleibt tagsüber keine Zeit — also landet die Büroarbeit im Feierabend oder am Wochenende. Ein Teufelskreis, den viele Handwerksbetriebe kennen: je voller der Auftragskalender, desto größer der Papierkram-Rückstau.",
    solutionIntro:
      "Mit unserer App entsteht das Angebot bereits während der Besichtigung — direkt auf dem Handy oder Tablet vor Ort. Es wird sofort an den Kunden geschickt, während der Eindruck von der Baustelle noch frisch ist. Keine Nacharbeit am Abend, keine vergessene Anfrage, kein Zettel, der in der Werkzeugkiste verschwindet.",
    bullets: [
      "Angebot direkt bei der Besichtigung erstellen und per Klick versenden — keine Nacharbeit danach",
      "Rechnungen laufen automatisiert, sobald ein Auftrag abgeschlossen ist",
      "Anfragen, die tagsüber reinkommen, landen strukturiert an einer Stelle statt verteilt auf Anruf, WhatsApp und E-Mail",
      "Termine für Besichtigungen und Ausführung koordinieren sich von selbst",
    ],
    faqDemo: [
      {
        q: "Wie schnell bekommt der Kunde nach der Besichtigung ein Angebot?",
        a: "Innerhalb weniger Minuten, direkt von der Baustelle aus — das Angebot entsteht während der Besichtigung, nicht erst am Abend am Schreibtisch.",
      },
      {
        q: "Werden auch Rechnungen automatisiert erstellt?",
        a: "Ja. Sobald ein Auftrag abgeschlossen ist, läuft die Rechnungsstellung automatisiert, ohne zusätzlichen Aufwand im Büro.",
      },
      {
        q: "Was passiert mit Anfragen, die tagsüber reinkommen?",
        a: "Sie landen strukturiert an einer zentralen Stelle statt verteilt auf Anruf, WhatsApp und E-Mail — nichts geht mehr unter.",
      },
    ],
    ctaText: "Kostenloses Erstgespräch anfragen",
  },
  {
    slug: "praxen",
    navLabel: "Für Praxen",
    eyebrow: "Für Zahnarzt- & Kieferorthopädie-Praxen",
    h1: "Die zehnte Anfrage zu Öffnungszeiten muss nicht mehr am Telefon landen.",
    metaDescription:
      "Automatisierung für Zahnarzt- und Kieferorthopädie-Praxen: Chatbot beantwortet wiederkehrende Patientenfragen, Terminplanung läuft automatisiert.",
    painPoint:
      "Ihr Praxisteam wird immer wieder mit denselben Fragen kontaktiert: Öffnungszeiten, ob ein Termin frei ist, welche Unterlagen mitzubringen sind, was eine Behandlung ungefähr kostet. Jede dieser Fragen ist einzeln schnell beantwortet — in Summe kosten sie aber wertvolle Zeit, die am Empfang und in der eigentlichen Patientenbetreuung fehlt.",
    solutionIntro:
      "Ein Chatbot auf Ihrer Website beantwortet genau diese wiederkehrenden Fragen automatisch und rund um die Uhr — auch außerhalb der Sprechzeiten. Ihr Team bekommt nur noch die Anfragen, die wirklich ein persönliches Gespräch brauchen.",
    bullets: [
      "Chatbot beantwortet Standardfragen (Öffnungszeiten, Unterlagen, Kosten, Anfahrt) automatisch",
      "Terminanfragen werden vorstrukturiert erfasst, bevor das Praxisteam eingreifen muss",
      "Entlastung am Empfang, besonders in Stoßzeiten und außerhalb der Sprechstunden",
      "DSGVO-bewusster Umgang mit Patientendaten, transparent dokumentiert",
    ],
    faqDemo: [
      {
        q: "Welche Fragen kann der Chatbot für eine Praxis beantworten?",
        a: "Öffnungszeiten, ob ein Termin frei ist, welche Unterlagen mitzubringen sind und was eine Behandlung ungefähr kostet — die typischen wiederkehrenden Fragen am Empfang.",
      },
      {
        q: "Funktioniert der Chatbot auch außerhalb der Sprechzeiten?",
        a: "Ja, er beantwortet Standardfragen automatisch und rund um die Uhr, auch abends und am Wochenende.",
      },
      {
        q: "Ist das im Umgang mit Patientendaten DSGVO-konform?",
        a: "Der Umgang mit Patientendaten ist transparent dokumentiert und DSGVO-bewusst gestaltet — das ist Grundvoraussetzung, kein Nebenthema.",
      },
    ],
    ctaText: "Kostenloses Erstgespräch anfragen",
  },
  {
    slug: "immobilienverwalter",
    navLabel: "Für Immobilienverwalter",
    eyebrow: "Für Immobilienmakler & -verwalter",
    h1: "Nicht jede Mieter-Anfrage braucht einen Rückruf.",
    metaDescription:
      "Automatisierung für Immobilienverwalter und Makler: Chatbot beantwortet wiederkehrende Mieter- und Eigentümerfragen, Leads landen strukturiert und ohne Verzögerung.",
    painPoint:
      "Mieter und Eigentümer melden sich ständig mit denselben wiederkehrenden Fragen — zur Nebenkostenabrechnung, zum richtigen Ansprechpartner oder um eine Reparatur zu melden. Diese Standardanfragen überlagern oft die Anliegen, die wirklich Ihre persönliche Aufmerksamkeit brauchen, und neue Leads reagieren empfindlich auf jede Verzögerung.",
    solutionIntro:
      "Ein Chatbot übernimmt die wiederkehrenden Standardfragen automatisch, während echte Anliegen und neue Anfragen sofort strukturiert und mit allen nötigen Informationen bei Ihnen landen — ohne dass etwas untergeht.",
    bullets: [
      "Chatbot beantwortet wiederkehrende Fragen zu Nebenkosten, Ansprechpartnern und Reparaturmeldungen",
      "Neue Anfragen (z.B. von Interessenten) werden sofort erfasst statt erst nach Rückruf",
      "Weniger verpasste Leads durch schnelle Reaktionszeit — entscheidend bei stark nachgefragten Objekten",
      "Ein zentraler Überblick statt verstreuter Anfragen über Telefon, E-Mail und Portal-Nachrichten",
    ],
    faqDemo: [
      {
        q: "Welche Anfragen übernimmt der Chatbot für eine Hausverwaltung?",
        a: "Wiederkehrende Fragen zu Nebenkostenabrechnung, richtigem Ansprechpartner und Reparaturmeldungen — automatisch, ohne dass jemand ans Telefon muss.",
      },
      {
        q: "Was passiert mit neuen Interessenten-Anfragen?",
        a: "Die werden sofort strukturiert erfasst statt erst nach einem Rückruf — entscheidend, weil neue Leads empfindlich auf Verzögerung reagieren.",
      },
      {
        q: "Behalte ich noch den Überblick über alle Kanäle?",
        a: "Ja, ein zentraler Überblick ersetzt verstreute Anfragen über Telefon, E-Mail und Portal-Nachrichten.",
      },
    ],
    ctaText: "Kostenloses Erstgespräch anfragen",
  },
  {
    slug: "industrie",
    navLabel: "Für Industrie & Architekturbüros",
    eyebrow: "Für Industrie, herstellendes Gewerbe & Architekturbüros",
    h1: "Ein Lead-Bot, der aus Websitebesuchern qualifizierte Anfragen macht.",
    metaDescription:
      "Lead-Bot für Industrie, herstellendes Gewerbe und Architekturbüros: beantwortet Fachfragen, qualifiziert Anfragen und übergibt strukturierte Leads direkt an Ihren Vertrieb.",
    painPoint:
      "Ihre Website bekommt Besuch von Interessenten — aber nur ein Teil davon wird zu einer echten Anfrage. Viele springen ab, weil die passende Ansprechperson nicht sofort erreichbar ist oder eine einfache Fachfrage (Kapazitäten, Stückzahlen, Referenzprojekte, Ablauf einer Anfrage) unbeantwortet bleibt. Und wenn doch eine Anfrage reinkommt, fehlt oft die Vorqualifizierung: Budget, Projektumfang, Zeitrahmen — Ihr Vertrieb erfährt das meist erst im ersten Telefonat.",
    solutionIntro:
      "Ein seriös auftretender Lead-Bot auf Ihrer Website übernimmt beides gleichzeitig: Er beantwortet die typischen Fachfragen Ihrer Branche direkt und stellt anschließend gezielte Qualifizierungsfragen — Projektart, Umfang, Zeitrahmen, Budgetrahmen. Das Ergebnis ist keine anonyme Kontaktanfrage, sondern ein vorqualifizierter Lead, den Ihr Vertrieb direkt bearbeiten kann. Ein echtes Power-House für Ihren Vertrieb, das rund um die Uhr arbeitet.",
    bullets: [
      "Beantwortet Fachfragen zu Kapazitäten, Fertigungsverfahren, Referenzprojekten oder Planungsleistungen automatisch",
      "Stellt gezielte Qualifizierungsfragen (Projektart, Umfang, Zeitrahmen, Budget) statt nur Kontaktdaten zu sammeln",
      "Seriöser, professioneller Auftritt — passend für B2B-Entscheider in Industrie und Architektur",
      "Vorqualifizierte Leads landen strukturiert bei Ihrem Vertriebsteam, inklusive aller relevanten Angaben",
      "Genauso einsetzbar für herstellendes Gewerbe wie für Architektur- und Planungsbüros",
    ],
    faqDemo: [
      {
        q: "Welche Stückzahlen können Sie fertigen?",
        a: "Der Bot beantwortet das direkt anhand hinterlegter Fakten zu Ihrer Fertigungskapazität — ohne dass jemand aus Ihrem Team ans Telefon muss.",
      },
      {
        q: "Wie läuft eine Anfrage bei Ihnen konkret ab?",
        a: "Der Bot erklärt Ihren Ablauf Schritt für Schritt und nimmt dem Interessenten die Unsicherheit, was als Nächstes passiert.",
      },
      {
        q: "Um welches Projekt geht es, welcher Zeitrahmen ist geplant, welches Budget ist vorgesehen?",
        a: "Genau hier beginnt die Qualifizierung: Statt nur eine E-Mail-Adresse zu sammeln, fragt der Bot die Angaben ab, die Ihr Vertrieb sonst erst im ersten Gespräch bekommt.",
      },
    ],
    ctaText: "Kostenloses Erstgespräch anfragen",
  },
];

export const getSegment = (slug) => segments.find((s) => s.slug === slug);
